<template>
  <v-list-item
    #default="{ active }"
    color="white"
    :ripple="false"
    :value="item.id"
    @click="$emit('select')"
  >
    <v-list-item-content>
      <v-list-item-title class="neutral--text text-body-m">
        {{ item.title || item.attributes.name || item.label }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon v-if="active">
      <font-awesome-icon
        icon="fa-regular fa-check"
        class="brand-primary--text text--tone-400 z-100"
        size="lg"
      />
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-list-item__title {
    z-index: 100;
  }

  .v-list-item.v-list-item--link.theme--light {
    &::before {
      opacity: 0;
    }
  }

  .v-list-item.v-item--active.v-list-item--active.v-list-item--link.theme--light {
    &::before {
      border-radius: 8px!important;
      border: 1px solid var(--v-neutral-tone-200);
      background-color: var(--v-white-base);
      opacity: 1;
    }
  }
</style>
